import { BaseApiClient } from '@/services/baseApiClient';
import { RequestError, type RequestOptions, uploadFile } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import { ImportCustomEmissionFactorsFormField } from '@enmon/commons/lib/enmon';
import type {
  CreateEmissionRecordsResult,
  DeleteEmissionRecordsResult,
  GetEmissionRecordsResult,
  UpdateEmissionRecordsResult,
  ImportEmissionRecordsResult,
  DeleteEmissionRecordsArg,
  GetEmissionRecordsArg,
  UpdateEmissionRecordsArg,
  CreateEmissionRecordArg,
  ImportEmissionRecordsArg,
} from './types';

export class EmissionRecordsApiClient extends BaseApiClient {
  constructor() {
    super('api/emission-records');
  }

  public get(filter: GetEmissionRecordsArg, signal: RequestOptions['signal']): Promise<GetEmissionRecordsResult> {
    return this.http.get('', { query: getQuery(filter), signal });
  }

  public create(payload: CreateEmissionRecordArg): Promise<CreateEmissionRecordsResult> {
    return this.http.post('', payload);
  }

  public delete(emissionRecordId: DeleteEmissionRecordsArg): Promise<DeleteEmissionRecordsResult> {
    return this.http.delete(emissionRecordId);
  }

  public update({ payload, emissionRecordId }: UpdateEmissionRecordsArg): Promise<UpdateEmissionRecordsResult> {
    return this.http.patch(emissionRecordId, payload);
  }

  public async import({ importFile, attachments }: ImportEmissionRecordsArg): Promise<ImportEmissionRecordsResult> {
    const formData = new FormData();
    formData.append(ImportCustomEmissionFactorsFormField.ImportFile, importFile);

    attachments.forEach(attachment => {
      formData.append(ImportCustomEmissionFactorsFormField.Attachments, attachment);
    });

    try {
      return await uploadFile(`${this.http.urlPrefix}/import`, formData, { signal: undefined });
    } catch (e) {
      if (e instanceof RequestError && e.response.status === 412) {
        return await e.response.json<ImportEmissionRecordsResult>();
      }
      throw e;
    }
  }
}
